import { post } from './client'

export { fnSubmitContactForm, fnSubmitLead }

/**
 * @typedef {object} ContactFormData
 * @property {object} fields
 * @property {object} legalConsentOptions
 * @property {object} context
 */

/**
 * @typedef {object} ContactFormBody
 * @property {string} form_id
 * @property {string} portal_id
 * @property {ContactFormData} data
 */

/**
 * @typedef {object} ContactFormResponse
 * @property {boolean} ok
 */

/**
 * @param  {string} formId
 * @param  {string} portalId
 * @param  {ContactFormData} data
 * @return {Promise<ContactFormResponse>}
 */
async function fnSubmitContactForm(formId, portalId, data) {
  return post({
    method: 'SubmitContactForm',
    args: [formId, portalId, data]
  })
}

/**
 * @typedef {object} LeadData
 * @property {string} email
 * @property {string} first_name
 * @property {string} [phone]
 * @property {string} [promo_code]
 */

/**
 * @typedef {object} HubSpot
 * @property {object} [context]
 * @property {string} form_id
 * @property {string} portal_id
 * @property {object} [legalConsentOptions]
 */

/**
 * @typedef {object} SMS
 * @property {string} content
 * @property {string} recipient
 * @property {string} sender
 */

/**
 * @typedef {object} LeadBody
 * @property {LeadData} [data]
 * @property {HubSpot} [hubspot]
 * @property {SMS} [sms]
 */

/**
 * @typedef {object} LeadResponse
 * @property {boolean} ok
 */

/**
 * @param  {LeadBody} body
 * @return {Promise<LeadResponse>}
 */
async function fnSubmitLead(body) {
  return post({
    method: 'SubmitLead',
    args: [body]
  })
}
